import React, { PureComponent } from 'react';
import { injectStyles } from 'injectStyles';
import PropTypes from 'prop-types';
import * as analytics from 'analytics';

import LoadingPage from 'components/pages/status/LoadingPage';
import NotFoundPage from 'components/pages/status/NotFoundPage';

import { BreadcrumbsSchema, PageTypeSchema, FaqSchema } from 'components/Schema';
import PageHeader from 'components/PageHeader';
import PageContent from 'components/PageContent';
import FaqCategoryList from 'components/FaqCategoryList';

import { VRAGEN_PAGE_TITLE } from 'globalConst/const';
import { SCHEMA_PAGE_TYPE } from 'globalConst/schema-const';
import ContentTypeComponent from 'components/ContentTypeComponent';

const LINK_TO_CONTACT_PROPS = {
  contentTypeId: 'textFrame',
  buttonText: 'Contact opnemen',
  showTitle: false,
  text: '<p style="text-align:center">Liever even contact?</p>',
  title: '',
  url: '/contact',
  handleClick: analytics.faqContact,
  isNavLink: true,
};

class FaqLandingPage extends PureComponent {
  static defaultProps = {
    hidePlayer: false,
    hideSearch: false,
    isError: false,
    isLoading: false,
    categories: null,
    title: null,
    description: null,
  };

  static propTypes = {
    classes: PropTypes.object.isRequired,
    forceMiniPlayerState: PropTypes.func.isRequired,
    hidePlayer: PropTypes.bool,
    hideSearch: PropTypes.bool,
    isError: PropTypes.bool,
    isLoading: PropTypes.bool,
    setSearchHidden: PropTypes.func.isRequired,
    categories: PropTypes.array,
    title: PropTypes.string,
    description: PropTypes.string,
  };

  componentDidUpdate() {
    const { hidePlayer, hideSearch } = this.props;

    if (hidePlayer) {
      this.props.forceMiniPlayerState(true);
    }
    if (hideSearch) {
      this.props.setSearchHidden(true);
    }
  }

  componentWillUnmount() {
    const { hidePlayer, hideSearch } = this.props;

    if (hidePlayer) {
      this.props.forceMiniPlayerState(false);
    }
    if (hideSearch) {
      this.props.setSearchHidden(false);
    }
  }

  allQuestions = (allCategories) => allCategories.reduce((acc, cur) => acc.concat(cur.questions), []);

  render() {
    const { classes, isError, isLoading, categories, title, description } = this.props;

    if (isLoading) {
      return <LoadingPage />;
    }

    if (isError) {
      return <NotFoundPage />;
    }

    return (
      <div className={classes.faqLanding}>
        <PageTypeSchema type={SCHEMA_PAGE_TYPE.COLLECTION_PAGE} metadata={{ title, description }} />
        <PageHeader {...this.props}>{/* FAQ search */}</PageHeader>
        <BreadcrumbsSchema level2={VRAGEN_PAGE_TITLE} />
        <PageContent>
          <FaqSchema faqs={this.allQuestions(categories)} />
          <FaqCategoryList showQuestions {...this.props} />
          <ContentTypeComponent {...LINK_TO_CONTACT_PROPS} />
        </PageContent>
      </div>
    );
  }
}

const styles = (theme) => ({
  faqLanding: {
    display: 'block',
    width: '100%',
    maxWidth: 680,
    margin: '0 auto',
  },
  [theme.breakpoints.down('ml')]: {
    faqLanding: {
      maxWidth: '100%',
      minWidth: '100%',
    },
  },
});

export default injectStyles(styles)(FaqLandingPage);
